import { render } from "./Desestrece.vue?vue&type=template&id=67d0596a&scoped=true"
import script from "./Desestrece.vue?vue&type=script&lang=js"
export * from "./Desestrece.vue?vue&type=script&lang=js"

import "./Desestrece.vue?vue&type=style&index=0&id=67d0596a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67d0596a"]])

export default __exports__